import React from 'react';
import ProductInfoImages from '../ProductInfoImages/ProductInfoImages';
import LazyLoad from 'react-lazyload';

const AboutProductNew = (props) => {
  const { productData, descriptionRef, experimentUserType, showAPlusPlusExp } =
    props;

  const componentBasedOnUserType = () => {
    return (
      <LazyLoad height={100} once offset={100}>
        <ProductInfoImages productId={productData?.id} />
      </LazyLoad>
    );
    // switch (experimentUserType) {
    //     case "A":
    //         return (
    //             <AboutSection
    //                 productData={productData}
    //                 descriptionRef={descriptionRef}
    //             />
    //         );
    //     case "B":
    //         return (
    //             <LazyLoad height={100} once offset={100}>
    //                 <ProductInfoImages productId={productData?.id} />
    //             </LazyLoad>
    //         );
    //     // case "C":
    //     //     return (
    //     //         <>
    //     //             <LazyLoad height={100} once offset={100}>
    //     //                 <ProductInfoImages productId={productData?.id} />
    //     //             </LazyLoad>
    //     //             <AboutSection
    //     //                 productData={productData}
    //     //                 descriptionRef={descriptionRef}
    //     //                 showAPlusPlusExp={showAPlusPlusExp}
    //     //             />
    //     //         </>
    //     //     );
    //     default:
    //         return (
    //             <AboutSection
    //                 productData={productData}
    //                 descriptionRef={descriptionRef}
    //             />
    //         );
    // }
  };
  return componentBasedOnUserType();
};

export default AboutProductNew;
